<template>
  <div class="system-container">
    <div class="content" ref="table">
      <el-tabs type="card" class="content-tab" @tab-click="tabHandel">
        <el-tab-pane
          label="车辆品牌维护"
          v-if="getPermission('系统信息维护-车辆品牌维护', '查看')"
        >
          <brand />
        </el-tab-pane>
        <el-tab-pane
          label="车辆车型维护"
          v-if="getPermission('系统信息维护-车辆车型维护', '查看')"
        >
          <car-model />
        </el-tab-pane>
        <el-tab-pane
          label="车辆型号维护"
          v-if="getPermission('系统信息维护-车辆型号维护', '查看')"
        >
          <model-number v-if="model" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { brand, carModel, modelNumber } from './components/index'
export default {
  components: { brand, carModel, modelNumber },
  data () {
    return {
      model: false
    }
  },
  methods: {
    tabHandel (lab) {
      if (lab.index === '2') {
        this.model = true
      } else {
        this.model = false
      }
    },
    getPermission (val1, val2) {
      const permission = this.$store.state.home.permission
      let flag = true
      permission.map(menu => {
        if (menu.menuName === val1) {
          menu.permissions.map(per => {
            if (per.annotation === val2) {
              if (per.status === 0) {
                flag = false
              }
            }
          })
        }
      })
      return flag
    }
  }
}
</script>

<style lang="less" scoped>
.system-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .content {
    flex: 1;
    min-height: 0;
    background: #fff;
    padding: 20px;
    box-shadow: 0 0 6px 1px #acacac;
  }
}
</style>
<style  lang="less">
.el-tabs {
  height: 100%;
  display: flex;
  flex-direction: column;
  .el-tabs__content {
    flex: 1;
  }
  .el-tab-pane {
    height: 100%;
  }
}
.content-tab {
  .el-tabs__item {
    background-color: #e3e3e3;
    color: #7f7f7f;
  }
  .el-tabs__header .el-tabs__item.is-active {
    background-color: #409eff;
    color: #fff;
    border-bottom-color: #e4e7ed;
  }
  .el-tabs--card > .el-tabs__header .el-tabs__nav {
    border: 0;
  }
}
</style>

